import { render, staticRenderFns } from "./WinLayerPopWrap.vue?vue&type=template&id=6e59edb0"
import script from "./WinLayerPopWrap.vue?vue&type=script&lang=js"
export * from "./WinLayerPopWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e59edb0')) {
      api.createRecord('6e59edb0', component.options)
    } else {
      api.reload('6e59edb0', component.options)
    }
    module.hot.accept("./WinLayerPopWrap.vue?vue&type=template&id=6e59edb0", function () {
      api.rerender('6e59edb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/WinLayerPopWrap.vue"
export default component.exports